import React from "react"
import { Container, Row, Col } from "reactstrap"

const PrivacyPage = () => {
  return (
    <React.Fragment>
      <div className="page-content">
        <Container>
          <Row>
            <Col md={12}>
              <h1 className="text-center py-4">
                Privacy Policy{" "}
                <span className="text-muted fst-italic" style={{ fontSize: "16px", fontWeight: "normal" }}>
                  (Last updated: December 18th, 2022)
                </span>
              </h1>
            </Col>
          </Row>
          <div className="col-md-12">
            <h3>
              <strong>Reservation of Rights</strong>
            </h3>
            <p>
              We reserve the right to request that you remove all links or any
              particular link to our Website. You approve to immediately remove
              all links to our Website upon request. We also reserve the right
              to amend these terms and conditions and it’s linking policy at any
              time. By continuously linking to our Website, you agree to be
              bound to and follow these linking terms and conditions.
            </p>
            <h3>
              <strong>Removal of links from our website</strong>
            </h3>
            <p>
              If you find any link on our Website that is offensive for any
              reason, you are free to contact and inform us any moment. We will
              consider requests to remove links but we are not obligated to or
              so or to respond to you directly.
            </p>
            <p>
              We do not ensure that the information on this website is correct,
              we do not warrant its completeness or accuracy; nor do we promise
              to ensure that the website remains available or that the material
              on the website is kept up to date.
            </p>
            <h3>
              <strong>Security & Permissions</strong>
            </h3>
            <ul>
              <li>
                Administrators have full access to manage data (add, download, delete, and modify).
              </li>
              <li>
                Other users can'not delete or download any data by default, untill unless if permissions are explicitly granted by the administrator.
              </li>
              <li>
                Do not share your password with anyone.
              </li>
              <li>
                Change your password regularly to keep your account secure.
              </li>
              </ul>
              
            
            <h3>
              <strong>Disclaimer</strong>
            </h3>
            <p>
              To the maximum extent permitted by applicable law, we exclude all
              representations, warranties and conditions relating to our website
              and the use of this website. Nothing in this disclaimer will:
            </p>
            <ul>
              <li>
                limit or exclude our or your liability for death or personal
                injury;
              </li>
              <li>
                limit or exclude our or your liability for fraud or fraudulent
                misrepresentation;
              </li>
              <li>
                limit any of our or your liabilities in any way that is not
                permitted under applicable law; or
              </li>
              <li>
                exclude any of our or your liabilities that may not be excluded
                under applicable law.
              </li>
            </ul>
            <p>
              The limitations and prohibitions of liability set in this Section
              and elsewhere in this disclaimer: (a) are subject to the preceding
              paragraph; and (b) govern all liabilities arising under the
              disclaimer, including liabilities arising in contract, in tort and
              for breach of statutory duty.
            </p>
            <p>
              As long as the website and the information and services on the
              website are provided free of charge, we will not be liable for any
              loss or damage of any nature.
            </p>
          </div>
          <hr />
        </Container>
      </div>
    </React.Fragment>
  )
}

export default PrivacyPage
